<template>
  <div id="app">
    <div id="sidenav">
      <b-sidebar
        width="260px"
        id="sidebar-no-header"
        aria-labelledby="sidebar-no-header-title"
        no-header
        shadow
        no-close-on-route-change
        :visible="showmenu"
        v-if="Auth0loggedIn"
      >
        <template>
          <div id="links">
            <b-icon-list
              @click="(showmenu = !showmenu), setmargin('0px')"
              font-scale="2"
            ></b-icon-list>

            <br />
            <CustomLogo></CustomLogo>
            <hr />
          </div>
          <nav>
            <b-nav vertical>
              <b-nav-item
                v-if="
                  Auth0loggedIn &
                    (profileportal.includes('CLI') &
                      accessGroup.includes('OVR')) ||
                    profileportal.includes('SUP') ||
                    profileportal.includes('SYS') ||
                    profileportal.includes('SEN')
                "
                to="/Overview"
                ><BIconColumnsGap></BIconColumnsGap> Overview</b-nav-item
              >
              <b-nav-item
                v-if="
                  Auth0loggedIn &
                    (profileportal.includes('CLI') &
                      accessGroup.includes('END')) ||
                    profileportal.includes('SUP') ||
                    profileportal.includes('SYS')
                "
                to="/DevicesAndOutlets"
                ><BIconTabletLandscape></BIconTabletLandscape> Devices &
                Routers</b-nav-item
              >
              <b-nav-item
                v-if="
                  Auth0loggedIn &
                    (profileportal.includes('CLI') &
                      accessGroup.includes('LOC')) ||
                    profileportal.includes('SUP') ||
                    profileportal.includes('SYS')
                "
                to="/LocationGroups"
                ><b-icon-building></b-icon-building> Location Management</b-nav-item
              >

              <b-nav-item
                v-if="
                  Auth0loggedIn &
                    (profileportal.includes('CLI') &
                      accessGroup.includes('CLA')) ||
                    profileportal.includes('SUP') ||
                    profileportal.includes('SYS') ||
                    profileportal.includes('SEN')
                "
                to="/Dashboard"
                ><b-icon-eye></b-icon-eye> Clarence Monitoring
                System</b-nav-item
              >
              <!-- <b-nav-item
                v-if="
                  Auth0loggedIn &
                    (profileportal.includes('CLI') &
                      accessGroup.includes('WBU') ||
                      profileportal.includes('SUP') ||
                      profileportal.includes('SYS')) &
                    profileportal.includes('this is never happening is it now')
                "
                to="/WashbasinDashboard"
                ><BIconDroplet></BIconDroplet> AG Washbasin Units</b-nav-item
              > -->
              <!-- <b-nav-item
                v-if="
                  Auth0loggedIn &
                    (accessGroup.includes('WMS') ||
                      profileportal.includes('SUP') ||
                      profileportal.includes('SYS'))  &
                      profileportal.includes('this is never happening is it now')
                "
                to="/WaterManagementOverview"
                ><BIconClipboardCheck></BIconClipboardCheck> Water Management
                Services</b-nav-item
              > -->
              <b-nav-item
                v-if="
                  Auth0loggedIn &
                    (profileportal.includes('CLI') ||
                      profileportal.includes('SUP') ||
                      profileportal.includes('SYS')) ||
                    accessGroup.includes('NOT') ||
                      profileportal.includes('SEN')
                "
                to="/AlertsOverview"
                ><b-icon-bell></b-icon-bell> Notifications</b-nav-item
              >
              <b-nav-item
                v-if="Auth0loggedIn & profileportal.includes('CLI')"
                to="/Service"
                ><BIconInbox></BIconInbox> Service</b-nav-item
              >
              <b-nav-item
                v-if="
                  Auth0loggedIn &
                    ((profileportal.includes('CLI') &&
                      profileportal.includes('REP')) ||
                      profileportal.includes('SUP') ||
                      profileportal.includes('SPA') ||
                      profileportal.includes('SYS')) ||
                      profileportal.includes('SEN')||
                    accessGroup.includes('REP')
                "
                to="/ReportsOverview"
                ><b-icon-file-earmark-spreadsheet></b-icon-file-earmark-spreadsheet>
                Reports</b-nav-item
              >

              <b-nav-item
                v-if="
                  Auth0loggedIn &
                    (profileportal.includes('SUP') &
                      (accessGroup.includes('SPX') ||
                        accessGroup.includes('SPA')) ||
                      profileportal.includes('SYS'))
                "
                to="/SuperUser"
                ><b-icon-person-check></b-icon-person-check> Super
                User</b-nav-item
              >
              <!-- <b-nav-item
                v-if="
                  Auth0loggedIn
                  & (profileportal.includes('Phase TWO'))
                "
                to="/StockManagement"
                ><BIconSim/> Product Stock Management</b-nav-item
              > -->
              <b-nav-item
                v-if="
                  Auth0loggedIn &
                  (profileportal.includes('CLI') &
                   accessGroup.includes('RCM')) ||
                   (profileportal.includes('SUP')) ||
                  (profileportal.includes('SEN'))
                  "
                to="/RiskControlMeasures"
                ><BIconExclamationOctagon /> Risk Control Measures</b-nav-item
              >
              <b-nav-item
                v-if="
                  Auth0loggedIn &
                  (profileportal.includes('CLI') &
                  accessGroup.includes('VLB')) ||
                  (profileportal.includes('SUP')) ||
                  (profileportal.includes('SEN'))"
                to="/VirtualLog"
                ><BIconBook /> Virtual Logbook</b-nav-item
              >




              <b-nav-item
                v-if="
                  Auth0loggedIn &
                    (profileportal.includes('MAI') ||
                      profileportal.includes('SUP') ||
                      profileportal.includes('SYS'))
                "
                to="/Maintenance"
                ><b-icon-tools></b-icon-tools> Maintenance</b-nav-item
              >

              <b-nav-item
                v-if="
                  Auth0loggedIn &
                  (accessGroup.includes('SAV')) ||
                    (profileportal.includes('SUP') ||
                      profileportal.includes('SYS'))
                "
                to="/SavingCalculator"
                ><BIconCashCoin></BIconCashCoin> Saving Calculator</b-nav-item
              >
              <!-- <b-nav-item
                v-if="
                  Auth0loggedIn &
                    (profileportal.includes('RSK') ||
                      profileportal.includes('SUP') ||
                      profileportal.includes('SYS'))  &
                      profileportal.includes('this is never happening is it now')
                "
                to="/RiskAssessmentQuestionnaire"
                ><BIconExclamationDiamond></BIconExclamationDiamond> Risk
                Assessment</b-nav-item
              > -->
              <!-- <b-nav-item
                v-if="
                  Auth0loggedIn &
                    (profileportal.includes('TST') ||
                      profileportal.includes('SUP') ||
                      profileportal.includes('SYS'))  &
                      profileportal.includes('this is never happening is it now')
                "
                to="/Testers"
                ><BIconEyedropper></BIconEyedropper> Testing</b-nav-item
              > -->
            </b-nav>
          </nav>
        </template>
        <template #footer="{  }">
          <div id="sidebarfooter">
            <img src="./assets/AGTEALCROPPED.png" alt="Logo" width="50px" />
          </div>
        </template> 
      </b-sidebar>
    </div>
    <div id="topbanner" v-if="showTopBanner == true">
      <div id="burgermenu">
        <b-icon-list
          v-if="showmenu === false"
          @click="(showmenu = !showmenu), setmargin('260px')"
          font-scale="2"
        ></b-icon-list>
      </div>
      <div v-if="this.screenWidth > 1000">
        <div id="leftheader">
          <h3 class="bannername">{{ this.ParentCompany }}</h3>
        </div>
        <div id="rightheader">
          <b-dropdown id="dropdown-1" toggle-class="text-decoration-none" right>
            <template #button-content>
              <b-avatar
                variant="info"
                class="userBAvatar"
                :text="getUserInitials()"
              ></b-avatar>
            </template>
            <b-dropdown-item
              v-if="Auth0loggedIn"
              href="./pdf/Seraph_Protect_User_Guide_WaterManagement_Placeholder.pdf"
              target="_blank"
              >Quick Guide</b-dropdown-item
            >
            <b-dropdown-item v-if="Auth0loggedIn" @click="userView()"
              >My User</b-dropdown-item
            >
            <b-dropdown-item
              href="#"
              @click.prevent="login"
              v-if="!Auth0loggedIn"
              >Log In</b-dropdown-item
            >
            <b-dropdown-item
              href="#"
              v-if="Auth0loggedIn"
              @click.prevent="logout"
              >Log Out</b-dropdown-item
            >
          </b-dropdown>
          <p class="head">
            <b-button
              v-if="Auth0loggedIn && currentRouteName!='SavingCalculator'" 
              id="locations"
              @click="locationSelect()"
            >
              Current Location: {{ selectedlocation
              }}<b-icon-caret-down-fill></b-icon-caret-down-fill
            ></b-button>
          </p>
        </div>
      </div>
      <div v-if="this.screenWidth <= 1000">
        <b-row>
          <b-col cols="9">
            <h4 class="bannername">{{ this.ParentCompany }}</h4>
          </b-col>
          <b-col cols="3">
            <b-dropdown
              id="dropdown-1"
              toggle-class="text-decoration-none"
              right
            >
              <template #button-content>
                <b-avatar
                  variant="warning"
                  class="userBAvatar"
                  :text="getUserInitials()"
                ></b-avatar>
              </template>
              <b-dropdown-item
                v-if="Auth0loggedIn"
                href="./pdf/Seraph_Protect_User_Guide_WaterManagement_Placeholder.pdf"
                target="_blank"
                >Quick Guide</b-dropdown-item
              >
              <b-dropdown-item v-if="Auth0loggedIn" @click="userView()"
                >My User</b-dropdown-item
              >
              <b-dropdown-item
                href="#"
                @click.prevent="login"
                v-if="!Auth0loggedIn"
                >Log In</b-dropdown-item
              >
              <b-dropdown-item
                href="#"
                v-if="Auth0loggedIn"
                @click.prevent="logout"
                >Log Out</b-dropdown-item
              >
            </b-dropdown>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <p class="head">
              <b-button
                v-if="Auth0loggedIn && currentRouteName!='SavingCalculator'"
                id="locations"
                @click="locationSelect()"
              >
                Current Location: {{ selectedlocation
                }}<b-icon-caret-down-fill></b-icon-caret-down-fill
              ></b-button></p
          ></b-col>
          <b-col>
          </b-col>
        </b-row>
      </div>
    </div>

    <div class="container" v-if="this.showTopBanner == true">
      <br />
      <div class="row">
        <div class="col-12">
          <router-view :key="componentKey" />
        </div>
      </div>
    </div>
    <div class="" v-if="this.showTopBanner == false">
      <router-view :key="componentKey" />
    </div>
    <!--</div>-->
    <b-modal
      ref="locationselect"
      id="locationselect"
      title="Select Location to view"
      hide-footer
    >
      Selected Location : <br />
      <b> {{ this.selectedlocation }} </b>
      <hr />
      <b-overlay
        :show="modalThinking"
        bg-variant="transparent"
        bg-opacity="1"
        rounded="sm"
      >
        <b-list-group v-if="this.locationLength <= 8">
          <b-list-group-item
            button
            v-for="location in locations"
            @click="setlocation(location.text)"
            :key="location.value"
            class="d-flex justify-content-between align-items-center"
          >
            {{ location.text }}
            <b-badge
              :variant="location.variant"
              pill
              v-if="location.variant == 'info'"
            >
              &#10003;</b-badge
            >
          </b-list-group-item>
        </b-list-group>
        <!-- Numbers -->
        <div v-if="this.locationLength >= 8">
          <b-dropdown
            id="dropdown-left"
            text="0 - 9"
            variant="outline-info"
            class="m-2"
          >
            <b-dropdown-item
              v-on:click="setlocation(item.text)"
              v-for="item in Numbers"
              :key="item.value"
              >{{ item.text }}
              <b-badge
                :variant="item.variant"
                pill
                v-if="item.variant == 'info'"
              >
                &#10003;</b-badge
              ></b-dropdown-item
            >
          </b-dropdown>
          <b-dropdown
            id="dropdown-left"
            text="A - F"
            variant="outline-info"
            class="m-2"
          >
            <b-dropdown-item
              v-on:click="setlocation(item.text)"
              v-for="item in AtoF"
              :key="item.value"
              >{{ item.text }}
              <b-badge
                :variant="item.variant"
                pill
                v-if="item.variant == 'info'"
              >
                &#10003;</b-badge
              ></b-dropdown-item
            >
          </b-dropdown>
          <b-dropdown
            id="dropdown-left"
            text="G - L"
            variant="outline-info"
            class="m-2"
          >
            <b-dropdown-item
              v-on:click="setlocation(item.text)"
              v-for="item in GtoL"
              :key="item.value"
              >{{ item.text }}
              <b-badge
                :variant="item.variant"
                pill
                v-if="item.variant == 'info'"
              >
                &#10003;</b-badge
              ></b-dropdown-item
            >
          </b-dropdown>
          <b-dropdown
            id="dropdown-left"
            text="M - R"
            variant="outline-info"
            class="m-2"
          >
            <b-dropdown-item
              v-on:click="setlocation(item.text)"
              v-for="item in MtoR"
              :key="item.value"
              >{{ item.text }}
              <b-badge
                :variant="item.variant"
                pill
                v-if="item.variant == 'info'"
              >
                &#10003;</b-badge
              ></b-dropdown-item
            >
          </b-dropdown>
          <b-dropdown
            id="dropdown-left"
            text="S - Z"
            variant="outline-info"
            class="m-2"
          >
            <b-dropdown-item
              v-on:click="setlocation(item.text)"
              v-for="item in StoZ"
              :key="item.value"
              >{{ item.text }}
              <b-badge
                :variant="item.variant"
                pill
                v-if="item.variant == 'info'"
              >
                &#10003;</b-badge
              ></b-dropdown-item
            >
          </b-dropdown>
        </div>

        <br />
        <br />
        <b-button
          size="sm"
          variant="outline-info"
          v-on:click="changeLocations()"
          >Request Change to Accessible Locations</b-button
        >
      </b-overlay>
    </b-modal>

    <b-modal
      ref="LocAccessUpdate"
      id="LocAccessUpdate"
      title="Request Location Access Updates"
    >
      <b-form-group label="" v-slot="{ ariaDescribedby }">
        <b-form-radio-group
          id="radio-group-1"
          v-model="selectedLocationAction"
          :options="optionsLocation"
          :aria-describedby="ariaDescribedby"
          name="radio-options"
        ></b-form-radio-group>
      </b-form-group>
      <br />
      <b-form-input
        v-model="LocationToChange"
        placeholder="Location to action"
      ></b-form-input>
      <br />
      <b-button
        size="sm"
        variant="outline-info"
        @click="submitLocationRequest()"
        >Submit</b-button
      >
      <b-button
        size="sm"
        variant="outline-info"
        @click="cancelLocationRequest()"
        >Cancel</b-button
      >
    </b-modal>

    <b-modal ref="UserDetails" id="UserDetails" title="User Details">
      <MyUser></MyUser>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";
import axios from "axios";
import CustomLogo from "./components/CustomLogos.vue";
import MyUser from "../src/components/MyUser.vue";
import {
  // BIconExclamationDiamond,
  BIconBuilding,
  BIconBell,
  // BIconDroplet,
  BIconEye,
  // BIconClipboardCheck,
  BIconTools,
  BIconCashCoin,
  BIconInbox,
  // BIconSim,
  BIconFileEarmarkSpreadsheet,
  BIconCaretDownFill,
  BIconList,
  BIconPersonCheck,
  BIconColumnsGap,
  // BIconEyedropper,
  BIconTabletLandscape,
  BIconExclamationOctagon,
  BIconBook
} from "bootstrap-vue";

export default {
  created() {
    this.$auth.renewTokens().catch((err) => {
      err;
    });
    this.$root.$refs.A = this;
  },
  computed: {
    currentRouteName() {
        return this.$route.name;
    }
  },

  components: {
    // BIconExclamationDiamond,
    BIconInbox,
    BIconBuilding,
    BIconBell,
    BIconEye,
    // BIconClipboardCheck,
    BIconTools,
    BIconCashCoin,
    // BIconDroplet,
    BIconFileEarmarkSpreadsheet,
    BIconCaretDownFill,
    BIconList,
    BIconPersonCheck,
    BIconColumnsGap,
    // BIconEyedropper,
    BIconTabletLandscape,
    BIconExclamationOctagon,
    BIconBook,
    // BIconSim,
    MyUser,
    CustomLogo,
  },

  data() {
    return {
      selectedLocationAction: "",
      optionsLocation: [
        { text: "New Location Access", value: "Add" },
        { text: "Remove Location Access", value: "Remove" },
      ],
      get selectedlocation() {
        return localStorage.getItem("CurrentLocation");
      },
      set token(value) {
        localStorage.setItem("CurrentLocation", this.selectedlocation);
      },
      get ParentCompany() {
        return localStorage.getItem("ParentCompany");
      },

      componentKey: 0,
      Auth0loggedIn: false,
      profile: {},
      profileportal: null,
      themepref: this.$ThemePref,
      accessGroup: this.$AccessGroup,
      // UserLog: this.$UserURN,
      get UserLog() {
        return localStorage.getItem("UserURN");
      },
      set UserLogToken(value) {
        localStorage.setItem("UserURN", this.UserLog);
      },
      SubPaid: "",
      clCompany: localStorage.getItem("Company"),
      visible: false,
      // selectedlocation: localStorage.getItem("currentLocation"),
      locations: [],
      showmenu: true,
      UserName: localStorage.getItem("fullname"),
      locationLength: null,
      NameArray: [],
      Numbers: [],
      AtoF: [],
      GtoL: [],
      MtoR: [],
      StoZ: [],
      screenWidth: 0,
      MaxHeight: 0,
      modalThinking: false,
      LocationToChange: "",
      UserAccess: localStorage.getItem("accessGroup"),
      UserProfile: this.$ProfilePortal,
      showTopBanner: false,
    };
  },
  mounted() {
    const currentUrl = window.location.href;
    let test = currentUrl.indexOf("/", 10);
    if (typeof currentUrl[test + 1] != "string") {
      this.showTopBanner = false;
    } else {
      this.showTopBanner = true;
    }
  },

  beforeMount() {},

  methods: {
    onScreenResize() {
      window.addEventListener("resize", () => {
        this.updateScreenWidth();
      });
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
      if (this.screenWidth <= 1000) {
        this.showmenu = false;
        this.setmargin("0px");
      }
    },
    setUserData() {
      let ParentCompany = localStorage.getItem("ParentCompany");
      let SubCompany = localStorage.getItem("Company");

      let Company = "";
      if (
        localStorage.getItem("profileportal") == "SUP" ||
        localStorage.getItem("profileportal") == "SYS" ||
        localStorage.getItem("profileportal") == "TST"
      ) {
        Company = ParentCompany;
      } else {
        Company = SubCompany;
      }

      if (SubCompany == "") {
        Company = ParentCompany;
      }

      let LookUpURLCl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/lookup";
      let LookUpHeadersCl = this.$apikeyPost;
      let LookUpRequestCl = {
        RequestType: "SubStatus",
        Company: Company,
      };
      axios
        .post(LookUpURLCl, LookUpRequestCl, LookUpHeadersCl)
        .then((response) => {
          this.SubPaid = response.data.Values[0][0];
          // this.setLocation();

          if (this.SubPaid == "Unpaid") {
            this.$router.push("/Suspended");
          }
        });

      let LookUpURL =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/locations";
      let LookUpHeaders = this.$apikeyPost;
      let LookUpRequest = {
        RequestType: "UserLocations",

        LocationDict: [
          {
            UserURN: this.UserLog,
          },
        ],
      };

      axios.post(LookUpURL, LookUpRequest, LookUpHeaders).then((response) => {
        let locationresponse = response.data.Values;
        this.locations = [];
        this.Numbers = [];
        this.AtoF = [];
        this.GtoL = [];
        this.MtoR = [];
        this.StoZ = [];
        for (let q = 0; q < locationresponse.length; q++) {
          this.locations.push({
            value: locationresponse[q],
            text: locationresponse[q],
            variant: "info",
          });
        }
        this.selectedlocation = localStorage.getItem("CurrentLocation");

        // Do location list call for user and if its greater than a mildly large number such as 8

        for (let i = 0; i < this.locations.length; i++) {
          if (this.locations[i].text == localStorage.getItem("location")) {
            this.locations[i].variant = "info";
          } else {
            this.locations[i].variant = "outline-info";
          }

          if (this.locations[i].value[0] == "A") {
            this.AtoF.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "B") {
            this.AtoF.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "C") {
            this.AtoF.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "D") {
            this.AtoF.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "E") {
            this.AtoF.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "F") {
            this.AtoF.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "G") {
            this.GtoL.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "H") {
            this.GtoL.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "I") {
            this.GtoL.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "J") {
            this.GtoL.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "K") {
            this.GtoL.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "L") {
            this.GtoL.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "M") {
            this.MtoR.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "N") {
            this.MtoR.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "O") {
            this.MtoR.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "P") {
            this.MtoR.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "Q") {
            this.MtoR.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "R") {
            this.MtoR.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "S") {
            this.StoZ.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "T") {
            this.StoZ.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "U") {
            this.StoZ.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "V") {
            this.StoZ.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "W") {
            this.StoZ.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "X") {
            this.StoZ.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "Y") {
            this.StoZ.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "Z") {
            this.StoZ.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "0") {
            this.Numbers.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "1") {
            this.Numbers.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "2") {
            this.Numbers.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "3") {
            this.Numbers.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "4") {
            this.Numbers.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "5") {
            this.Numbers.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "6") {
            this.Numbers.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "7") {
            this.Numbers.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "8") {
            this.Numbers.push(this.locations[i]);
          } else if (this.locations[i].value[0] == "9") {
            this.Numbers.push(this.locations[i]);
          }
        }
        Vue.prototype.$locations = this.locations;
        this.locationLength = this.locations.length;

        if (this.selectedlocation == "Unassigned") {
          localStorage.setItem("CurrentLocation", response.data.Values[0]);
          localStorage.setItem("location", response.data.Values[0]);
          this.selectedlocation = response.data.Values[0];
          this.setlocation();
        }
      });
    },

    ...mapActions(["setView"]),
    ChangeView: function(payload) {
      localStorage.setItem("themepref", payload);

      this.setView(payload);

      location.reload();
    },

    changeLocations() {
      this.$refs["LocAccessUpdate"].show();
    },
    cancelLocationRequest() {
      this.selectedLocationAction = "";
      this.LocationToChange = "";
    },
    submitLocationRequest() {
      if ((this.selectedLocationAction != "") & (this.LocationToChange != "")) {
        // Do the email thing
        let EmailPosturl =
          "https://d9py0urct8.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/emailgateway";
        let EmailData = {
          ToEmail: "support@seraphprotect.online",
          EmailText:
            "Hello, \\n\\nThe following User has requested a location change. \\n\\nPlease follow up with the appropriate steps.\\nRequested Action: " +
            this.selectedLocationAction +
            "\\nRequested Location: " +
            this.LocationToChange +
            "\\nUser is: " +
            this.UserName +
            "\\n\\nSent from Seraph Protect",
          EmailSubject: "User Location Access Change Request",
        };
        let EmailPostHeaders = this.$apikeyPost;
        axios
          .post(EmailPosturl, EmailData, EmailPostHeaders)
          .then((response) => {
            alert("Location Access Update has been requested");
            response;
            this.HistorySubmit();
          })
          .catch((err) => {
            "Error: ===", err;
          });
      } else if (
        (this.selectedLocationAction == "") &
        (this.LocationToChange != "")
      ) {
        // Tell user to select action
        alert("Please select an action before submitting");
      } else if (
        (this.selectedLocationAction != "") &
        (this.LocationToChange == "")
      ) {
        // Tell user to type in a location
        alert("Please input a location before submitting");
      } else if (
        (this.selectedLocationAction == "") &
        (this.LocationToChange == "")
      ) {
        // Tell user to actually do something and not just click buttons for the sake of it
        alert("Please ensure all fields are filled before submitting");
      }
    },
    HistorySubmit() {
      let current = new Date();
      let HistoryDate =
        current.getFullYear() +
        "-" +
        (current.getMonth() + 1) +
        "-" +
        current.getDate();
      let HistoryTime =
        current.getHours() +
        ":" +
        current.getMinutes({ minimumIntegerDigits: 2 }) +
        ":" +
        current.getSeconds({ minimumIntegerDigits: 2, useGrouping: false });
      let LookUpURLHist =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/adminhistory";
      let LookUpHeadersHist = this.$apikeyPost;
      this.LookUpRequest = {
        UserURN: this.UserURN,
        HistoryDate: HistoryDate,
        HistoryTime: HistoryTime,
        HistoryNote: this.HistoryNote,
        ProfilePortal: this.UserProfile,
      };
      axios
        .post(LookUpURLHist, this.LookUpRequest, LookUpHeadersHist)
        .then((response) => {
          response;
        });
    },
    getUserInitials() {
      this.userInitials = localStorage.getItem("UserInitials");
      return this.userInitials;
    },

    login() {
      this.$auth.login();
    },
    logout() {
      this.showmenu = false;
      this.setmargin("0px");
      this.selectedlocation = "";
      let current = new Date();
      let HistoryDate =
        current.getFullYear() +
        "-" +
        (current.getMonth() + 1) +
        "-" +
        current.getDate();
      let HistoryTime =
        current.getHours() +
        ":" +
        current.getMinutes({ minimumIntegerDigits: 2 }) +
        ":" +
        current.getSeconds({ minimumIntegerDigits: 2, useGrouping: false });
      /*  let UserName=this.profile.name; */
      let UserPortal = this.$ProfilePortal;
      let UserURN = this.$UserURN;

      let EventHistory = "Logged Out";

      axios.get("https://www.cloudflare.com/cdn-cgi/trace").then((response) => {
        this.response = response.data;
        let UserIPAddress = this.response.substring(
          this.response.search("ip=") + 3,
          this.response.search("ts=") - 1
        );
        let sendUrl =
          "https://bg4rfm4uqd.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/userhistory";

        let sendData = {
          UserURN: UserURN,
          UserIPAddress: UserIPAddress,
          HistoryDate: HistoryDate,
          HistoryTime: HistoryTime,
          HistoryNote: EventHistory,
          ProfilePortal: UserPortal,
        };
        let sendHeaders = this.$apikeyPost;
        axios
          .post(sendUrl, sendData, sendHeaders)
          .then((response) => {
            response;
          })
          .catch((err) => "error: " + err);
      });

      this.$auth.logout();
    },
    handleLoginEvent(data) {
      this.profile = data.profile;
      this.Auth0loggedIn = data.Auth0loggedIn;
      this.profileportal = data.profileportal;
      this.themepref = data.themepref;
      this.accessGroup = data.accessGroup;
      this.setUserData();
    },
    locationSelect() {
      this.$refs["locationselect"].show();
    },
    setlocation(value) {
      this.modalThinking = true;
      for (let i = 0; i < this.locations.length; i++) {
        if (value == this.locations[i].text) {
          this.locations[i].variant = "info";
          this.selectedlocation = value;
          localStorage.setItem("CurrentLocation", value);
          localStorage.setItem("location", value);
          // if (this.UserProfile == "SUP" || this.UserProfile == "SYS") {
          //   this.modalThinking = false;

          //   this.$refs["locationselect"].hide();

          //   this.componentKey += 1;
          //   return;
          // }
        } else {
          this.locations[i].variant = "outline-info";
        }
      }

      this.NameArray = localStorage.getItem("fullname").split(/[ ,]+/);

      let MetaAccessString = localStorage.getItem("accessGroup");

      let MetaAccessArray = MetaAccessString.split(",");

      let LookUpUrl9 =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/auth0";
      let LookUpHeaders9 = this.$apikeyPost;
      let LookUpRequest9 = {
        UserMetaParentCompany: localStorage.getItem("ParentCompany"),
        Blocked: "",
        RequestType: "Update",
        Email: "",
        UserMetaCompany: localStorage.getItem("Company"),
        UserMetaLocation: this.selectedlocation,
        AppMetaAccess: MetaAccessArray,
        AppMetaPortal: localStorage.getItem("profileportal"),
        FirstName: this.NameArray[0],
        LastName: this.NameArray[1],
        Name: localStorage.getItem("fullname"),
        UserID: localStorage.getItem("UserURN"),
        // Blocked: "",
        // RequestType: "Update",
        // Email: "",
        // UserMetaCompany: "",
        // UserMetaLocation: "Unassigned",
        // UserMetaParentCompany: "Angel Guard",
        // AppMetaAccess: ["SOS", "FIN", "SPA"],
        // AppMetaPortal: "SUP",
        // FirstName: "Super",
        // LastName: "Angel",
        // Name: "Super Angel",
        // UserID: "auth0|6454bb5614d64fe325280686",
      };
      axios
        .post(LookUpUrl9, LookUpRequest9, LookUpHeaders9)
        .then((response) => {
          response;
          this.editClientUserDB();
        });

      // this.$router.go();

      // this.locations = [
      //   {
      //     value: "DemonAttackHQ",
      //     text: "Demon Attack HQ",
      //     variant: "success",
      //   },
      //   {
      //     value: "BigBuilding",
      //     text: "Big Building Hospital",
      //     variant: "outline-info",
      //   },
      //   {
      //     value: "Angel Guard HQ",
      //     text: "Angel Guard HQ",
      //     variant: "outline-info",
      //   },
      //   {
      //     value: "StSimon",
      //     text: "St Simons Hospital",
      //     variant: "outline-info",
      //   },
      //   {
      //     value: "Gotham",
      //     text: "Gotham General Hospital",
      //     variant: "outline-info",
      //   },
      // ];

      // UNCOMMENT BELOW CODE TO MAKE IT WORK AGAIN

      // this.selectedlocation = value;
      // localStorage.setItem("CurrentLocation", value);
      // this.$refs["locationselect"].hide();
      // this.$router.go();
    },

    editClientUserDB() {
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/useradmin";
      let LookUpHeaders = this.$apikeyPost;
      let LookUpRequest = {
        RequestType: "Edit",
        UserDict: [
          {
            UserURN: localStorage.getItem("UserURN"),
            FirstName: this.NameArray[0],
            LastName: this.NameArray[1],
            Location: "",
            DefaultLocation: this.selectedlocation,
            AccessGroups: localStorage.getItem("accessGroup"),
          },
        ],
      };
      axios.post(LookUpUrl, LookUpRequest, LookUpHeaders).then((response) => {
        response;
        this.modalThinking = false;

        this.$refs["locationselect"].hide();

        this.componentKey += 1;
      });
    },

    userView() {
      this.$refs["UserDetails"].show();
    },

    setmargin(value) {
      let r = document.querySelector(":root");
      r.style.setProperty("--appmargin", value);
    },
    AuthSidebar() {
      if (this.Auth0loggedIn == false) {
        this.setmargin("0px");
      }
      if (this.Auth0loggedIn == true) {
        this.setmargin("260px");
        this.updateScreenWidth();
        this.onScreenResize();
      }
    },
  },
  watch: {
    Auth0loggedIn() {
      this.AuthSidebar();
    }
  },
};
</script>

<style>
:root {
  --appmargin: 0px;
}

ul {
  margin-left: 0px;
}

.navbar-nav {
  margin-left: 0px;
  padding-left: 0px;
  align-content: center;
  width: 100%;
}
p.Menu {
  text-align: center;
  color: rgb(255, 255, 255);
}

p.head {
  text-align: right;
  font-size: 20px;
  color: rgb(255, 255, 255);
  padding-top: 10px;
}

#locations {
  margin-right: 10px;
  background-color: rgb(109, 136, 195);
  border: none;
}

#dropdown-1__BV_toggle_ {
  margin-right: 10px;
  background-color: rgb(109, 136, 195);
  border: none;
}

.menu-card-header {
  padding: 0;
  background-color: rgb(238, 238, 238);
  border: none;
}

#MenuToggle {
  background-color: rgb(238, 238, 238);
  color: grey;
  text-align: left;
  border: none;
  padding-left: 15px;
}

#MenuToggle:hover {
  background-color: rgb(218, 168, 6);
}

#MenuToggle:focus {
  background-color: lightgray;
}

#AGFooterInfo {
  position: sticky;
  width: 100%;
  bottom: 0;
  margin-top: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: black;
  z-index: 1001;
}

#AGFooterInfo h4 {
  font-size: 0.9rem;
  color: white;
  z-index: 1001;
}

#AGFooterLogo {
  height: 45px;
  margin-bottom: 0.2rem;
}

.nav-item {
  color: white;
}

.nav-item p:active {
  color: rgb(255, 255, 255);
  padding: 0;
  margin: 0;
  font-weight: 400;
  font-size: 1rem;
  padding: 0 0.5rem 0 0.5rem;
}
.navbar-toggler {
  color: grey;
  font-size:1.5rem;
  text-align: left;
}

.navbar-toggler:active {
  border: none;
  color: rgb(218, 168, 6);
  background-color: grey;
}
.navbar-toggler:hover {
  border: none;
  background-color: rgb(218, 168, 6);
}

.navbar-dark .navbar-nav .nav-link {
  color: white;
}

#accordion-1 {
  background-color: rgb(238, 238, 238);
}

li {
  border-style: none;
  position: relative;
  z-index: 100;
}

li.nav-item {
  border: none;
  padding: none;
  margin: none;
}

li.nav-item::marker {
  color: rgba(255, 0, 0, 0);
}

.list-group-item {
  text-align: center;
  border: none;
}

.bg-light {
  border-bottom: solid 1px;
}

.SubAlert {
  margin: 0;
}

#sidebarfooter {
  background: rgb(78, 205, 196);
  text-align: center;
}
#topbanner {
  float: right;
  background-color: rgb(109, 136, 195);
  color: white;
  width: 100%;
}
#burgermenu {
  float: left;
  padding: 5px;
  margin: 5px;
}
h5.footer {
  color: white;
  font-size: x-small;
}

#sidebar-no-header-title {
  color: white;
  text-shadow: 1px 1px #000000;
  padding: 0;
}

#dropdown-1 {
  float: right;
  background-color: rgb(109, 136, 195);
}

#CurrentRoute {
  float: left;
  color: rgb(52, 58, 64);
}
#AGFooterLogo {
  height: 45px;
  
  margin-right: 10%;
}

#AGNavLogo {
  height: 45px;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
}

#pad {
  margin-bottom: 20px;
  margin-top: 15px;
  border-top-style: solid;
  border-bottom-style: solid;
  background-color: rgb(238, 238, 238);
}

.b-sidebar-body {
  background-color: rgb(78, 205, 196);
  width: 100%;
}

#links {
  align-content: center;
  text-align: center;
  background-color: rgb(78, 205, 196);
}

.flex-column {
  width: auto;
  text-align: left;
}

.nav a {
  color: rgb(48, 52, 62);
  font-size:0.9rem;
}

.nav a:hover {
  color: rgb(78, 205, 196) !important;
  background-color: rgb(48,52,62) !important;
}

.nav a.router-link-active {
  background-color: rgb(109, 136, 195) !important;
  color: rgb(255, 255, 255) !important;
}

#app {
  margin-left: var(--appmargin);
}

.nav-link.active {
  background-color: rgb(109, 136, 195) !important;
  color: rgb(255, 255, 255) !important
}

.locationButtons {
  width: 100%;
  text-align: left;
}
.locationButtonGroup {
  align-items: stretch;
}

#leftheader {
  width: 40%;
  float: left;
}

#rightheader {
  width: 55%;
  float: right;
}

.bannername {
  margin-top: 10px;
}

.smallmenu {
  color: white;
  font-size: small;
  font-style: italic;
  text-shadow: 0.5px 0.5px #000000;
}
</style>
